export const ALL_CATEGORIES = 'ALL_CATEGORIES'
export const ALL_CATEGORIES_SUCCESS = 'ALL_CATEGORIES_SUCCESS'
export const ALL_CATEGORIES_FAILURE = 'ALL_CATEGORIES_FAILURE'
export const CATEGORY_BY_ID = 'CATEGORY_BY_ID'
export const CATEGORY_BY_ID_SUCCESS = 'CATEGORY_BY_ID_SUCCESS'
export const GET_CONTENTS = 'GET_CONTENTS'
export const GET_CONTENTS_SUCCESS = 'GET_CONTENTS_SUCCESS'